import { Record } from 'immutable';
const defaults = {
  communicationTypeId: null,
  label: '',
  required: false
};
export default class LegalConsentCheckbox extends Record(defaults) {}
export function createLegalConsentCheckbox(json) {
  return new LegalConsentCheckbox(json);
}